import { CategoryCard } from '../components/home/CategoryCard';
import { WeatherIcon } from '../components/home/WeatherIcon';
import { useHome } from '../hooks/useHome';
import { HOME_CATEGORIES } from '../config/homeCategories';

/**
 * Home workbench — greeting header + category tiles.
 * Mirrors the osdu-insights "My Reports" landing layout.
 */
export const HomePage: React.FC = () => {
  const { greeting, firstName, weather } = useHome();

  const toolCount = HOME_CATEGORIES.reduce((sum, cat) => sum + cat.tools.length, 0);

  return (
    <div className="space-y-6">
      {/* Welcome */}
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
              {greeting}, {firstName}
            </h1>
            {weather !== null && (
              <>
                <span className="text-gray-300 dark:text-gray-600">•</span>
                <span className="flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400">
                  <WeatherIcon code={weather.code} />
                  {weather.temp}°C in Stavanger
                </span>
              </>
            )}
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            You have {toolCount} tool{toolCount !== 1 ? 's' : ''} available
          </p>
        </div>
      </div>

      {/* Category tiles */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {HOME_CATEGORIES.map((category) => (
          <CategoryCard key={category.id} category={category} />
        ))}
      </div>
    </div>
  );
};

export default HomePage;
